// Applied before CSS paints; the review wrapper switches palettes without reloading the shop.
(() => {
  const valid = value => value === 'terracotta' ? 'terracotta' : 'bordeaux';
  const apply = (value, updateUrl = false) => {
    const palette = valid(value);
    document.documentElement.dataset.palette = palette;
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('palette', palette);
      history.replaceState(null, '', url);
    }
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', palette === 'bordeaux' ? '#fcfaf7' : '#fffaf3');
  };
  apply(new URLSearchParams(location.search).get('palette'));
  window.addEventListener('message', event => {
    if (event.origin !== location.origin || event.source !== parent || event.data?.type !== 'advent-palette') return;
    apply(event.data.palette, true);
  });
})();
